'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoFolder = function IoFolder(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.6 15c1.4 0 1.5 0.5 1.4 1.4l-0.9 14.5c-0.1 0.9-0.3 1.6-1.7 1.6h-24.7c-1.5 0-1.6-0.7-1.7-1.6l-1-14.3c-0.1-0.9 0-1.6 1.4-1.6h27.2z m-0.3-3.8l0.1 2.6h-26.8c0-0.5 0.3-3.6 0.4-5 0.2-1.4 0.7-1.3 2-1.3h5.8c2.2 0 1.8 0 2.9 1.2 1.3 1.4 1.5 1.3 3.2 1.3h11.2c0.9 0 1.2 0.2 1.2 1.2z' })
        )
    );
};

exports.default = IoFolder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/folder.js
// module id = 2059
// module chunks = 0